// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ACQG","inner":"Footer_inner__2TbwP"};